<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SoN0kn/images/cover.jpg?1688985128992" alt="This image is the cover for the book MATERNAL AND CHILD HEALTH NURSE, Certified Nurse Examination Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">MATERNAL AND CHILD HEALTH NURSE, Certified Nurse Examination Series
      </h1>
      <p class="bookDescription body article font2">
        <p>The Certified Nurse Examination Series prepares individuals for licensing and certification conducted by the American Nurses Credentialing Center (ANCC), the National Certification Corporation (NCC), the National League for Nursing (NLN), and other organizations. The Maternal and Child Health Nurse Passbook® provides a series of informational texts as well as hundreds of questions and answers in the areas that will likely be covered on your upcoming exam.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        National Learning Corporation
      </h2>
      
      <p class="authorDescription body article">National Learning Corporation has been a leading publisher of test-preparation Passbooks® for more than 50 years, with 6,000 titles available across 22 series.  The Career Examination Series features thousands of titles designed to prepare test candidates for their upcoming civil-service job exam.  Each book in the Career Series offers practice through multiple-choice questions and answers in relevant subject areas, as well as informative texts to aid in understanding the study material.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      National Learning Corporation
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ff99ae9